import {twJoin} from 'tailwind-merge'
import {useTranslation} from 'react-i18next'

import {LazyImage, Slideout, SlideoutBody, SlideoutContainer, SlideoutFooter, SlideoutHeader} from '@sdox/ui'

import {ContactInfoRows} from './ContactInfoRows'
import {OpeningHoursDisplay} from './OpeningHoursDisplay'
import {ContactInfoButtons} from './ContactInfoButtons'

import type {DealerStampProps} from '../DealerStamp'

interface DealerStampDialogProps extends DealerStampProps{
  isOpen: boolean
  onClose: () => void
}

export const DealerStampDialog = (props: DealerStampDialogProps ) => {
  const {isOpen, onClose, name, image, address, phone, email, coordinates, openingHours} = props
  const {t} = useTranslation()

  return (
    <Slideout
      open={isOpen}
      onClose={onClose}
      variant={'content'}
    >
      <SlideoutContainer className={'!min-w-0 !max-w-[600px] bg-surface-primary @container'}>
        <SlideoutHeader
          sticky={!!image}
          onClose={onClose}
        />
        <SlideoutBody>
          {image ? (
            <LazyImage
              src={image.url}
              placeholderSrc={image.placeholderUrl}
              alt={image.alt ?? t('common:dealerStamp.locationImgAlt')}
              className={'aspect-[16/11] w-full object-cover object-center'}
            />
          ) : null}
          <div className={'px-spacing-20 sm:px-spacing-32'}>
            <h4
              className={twJoin(
                'line-clamp-3 py-spacing-40 text-center text-h4',
                !image && 'pt-0',
              )}
            >
              {name ? name : t('common:dealerStamp.contactToDealer')}
            </h4>
            <ContactInfoButtons
              coordinates={coordinates}
              mail={email}
              phone={phone}
            />
            <ContactInfoRows
              address={address}
              coordinates={coordinates}
              mail={email}
              phone={phone}
            />
            {openingHours ? (<OpeningHoursDisplay openingHours={openingHours}/>) : null}
          </div>
        </SlideoutBody>
        <SlideoutFooter
          variant={'content'}
          primary={{
            variant:'outline',
            onClick: onClose,
            children: t('common:close'),
          }}
        />
      </SlideoutContainer>
    </Slideout>
  )
}
